<template>
    <section>
			<div ref="navbarh-project" id="navbar-project">
                <nav>
                    <img class="img-nav-project"  src="../assets/img/LogoSecundario.svg">
                    <label id="label-project" class="label-nav-project">NOMBRE PROYECTO</label>
                </nav>
                <input type="checkbox" id="nav-project" class="input-menu-project">
                <label for="nav-project">
                    <div class="menu-project">
                        <span class="hamburguer-project"></span>
                    </div>
                </label>
                <ul class="ul-menu-project">
                    <li class="li-menu-project" v-on:click="habilitarp">
						<!-- <a v-on:click="habilitarp" href="" class="a-menu-project">{{ $t('header.home') }}</a> -->
						<router-link :to="{path: '/'}" class="a-menu">{{ $t('header.home') }}</router-link>
					</li>
                    <li class="li-menu-project" v-on:click="habilitarp">
						<!-- <a v-on:click="habilitarp" href="#about-section" class="a-menu-project">{{ $t('header.about') }}</a> -->
						<router-link :to="{path: '/#about-section'}" class="a-menu">{{ $t('header.about') }}</router-link>
					</li>
                    <li class="li-menu-project" v-on:click="habilitarp">
						<!-- <a v-on:click="habilitarp" href="#team-section" class="a-menu-project">{{ $t('header.team') }}</a> -->
						<router-link :to="{path: '/#team-section'}" class="a-menu">{{ $t('header.team') }}</router-link>
					</li>
                    <li class="li-menu-project" v-on:click="habilitarp">
						<!-- <a v-on:click="habilitarp" href="" class="a-menu-project">{{ $t('header.services') }}</a> -->
						<router-link :to="{path: '/#service-section'}" class="a-menu">{{ $t('header.services') }}</router-link>
					</li>
                    <li class="li-menu-project" v-on:click="habilitarp">
						<!-- <a v-on:click="habilitarp" href="" class="a-menu-project">{{ $t('header.portfolio') }}</a> -->
						<router-link :to="{path: '/#portfolio-section'}" class="a-menu">{{ $t('header.portfolio') }}</router-link>
					</li>
                    <li class="li-menu-project" v-on:click="habilitarp">
						<!-- <a v-on:click="habilitarp" href="#customers-section" class="a-menu-project">{{ $t('header.customers') }}</a> -->
						<router-link :to="{path: '/#customers-section'}" class="a-menu">{{ $t('header.customers') }}</router-link>
					</li>
                    <li class="li-menu-project" v-on:click="habilitarp">
						<!-- <a v-on:click="habilitarp" href="#contact-section" class="a-menu-project">{{ $t('header.contact')}}</a> -->
						<router-link :to="{path: '/#contact-section'}" class="a-menu">{{ $t('header.contact') }}</router-link>
					</li>
                </ul>
                <div class="div-lenguaje-project">
                    <LanguageSwitcher></LanguageSwitcher>
                </div>
                <div class="header-azul-project"></div>
            </div>
			<div id="start" class="container-fluid container-project">
				<b-row class="mt-4">
					<b-col cols="12">
						<div class="back-fixed">
							<router-link class="link-back" :to="{path: '/#portfolio-section'}"><b-icon icon="chevron-left"></b-icon> REGRESAR</router-link>
						</div>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="4" offset="2">
						<span class="s-title">Cliente: </span>
						<span class="s-content">Exitus Mujer</span>
					</b-col>
					<b-col cols="3">
						<span class="s-title">Giro: </span>
						<span class="s-content">Créditos grupales</span>
					</b-col>
					<b-col cols="3">
						<span class="s-title">Año: </span>
						<span class="s-content">2020</span>
					</b-col>
				</b-row>
				<b-row class="mt-4 mb-5">
					<b-col cols="4" offset="2">
						<span class="s-title">Servicio: </span>
						<span class="s-content">Branding / Community Management</span>
					</b-col>
					<b-col cols="4">
						<span class="s-title">Plataforma: </span>
						<span class="s-content">WhatsApp y Facebook</span>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="2">
						<div class="p-text"><div class="div-back"><span>Anterior </span><b-icon icon="chevron-up"></b-icon></div></div>
					</b-col>
					<b-col cols="8">
						<div class="text-center">
							<b-img class="image-1" :src="require('../assets/img/projects/exitus/image1.png')" fluid alt="Responsive image"></b-img>
						</div>
					</b-col>
					<b-col cols="2">
						<div class="p-text"><div class="div-next"><span>Siguiente </span><b-icon icon="chevron-down"></b-icon></div></div>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="4" offset="1">
						<div class="objective">
							<h4>01 EL OBJETIVO</h4>
							<p>
								El objetivo fue crear una marca que a primer vistazo le hablara a la audiencia meta, es decir, a las mujeres. Lograr crear una identidad de marca que empoderé a las mujeres a cumplir y valorar sus sueños; a crear una cultura en la que sus deseos son lo más importante. 
								<br><br>
								El reto para Marabunta fue crear un concepto de marca que si bien tiene un toque muy femenino, con formas orgánicas y paletas de color alegres, conviva bien con el branding ya establecido de Exitus Credit, una financiera bien posicionada. La idea era dejar ver que Exitus Mujer forma parte de esta gran empresa; pero al mismo tiempo siendo atractiva a las mujeres emprendedoras, dueñas de pequeños negocios que están por pedir un crédito grupal.
							</p>
						</div>
					</b-col>
					<b-col cols="5">
						<div class="objective-2">
							<span class="txt-1">IDEAS INICIALES DE LOGOTIPO</span>
							<div class="text-center o-image1">
								<b-img class="image-0" :src="require('../assets/img/projects/exitus/image2.png')" fluid alt="Responsive image"></b-img>
							</div>
							<div class="text-center">
								<b-img class="image-0" :src="require('../assets/img/projects/exitus/image2.png')" fluid alt="Responsive image"></b-img>
							</div>
						</div>
					</b-col>
					<b-col cols="8" offset="2">
						<div class="objective-3">
							<span class="txt-2">LOGOTIPO</span>
							<div class="text-center">
								<b-img class="image-4" :src="require('../assets/img/projects/exitus/image4.png')" fluid alt="Responsive image"></b-img>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="10" offset="1">
						<div class="design">
							<h4>02 DISEÑO</h4>
							<p>
								Lorem ipsum dolor sit amet consectetur, adipisicing elit. Tenetur debitis cum, mollitia recusandae blanditiis distinctio! Dignissimos molestias possimus voluptatibus sunt. Doloribus, sint iure. Labore sapiente sequi atque dolore temporibus animi?
								<br> <br>
								Lorem ipsum dolor sit, amet consectetur adipisicing elit. Natus rem quia hic eos praesentium consequatur fugit at, incidunt sed corrupti optio, voluptas, placeat facilis est assumenda itaque quae? Rem, autem!
							</p>
						</div>
					</b-col>
					<b-col cols="7" offset="1">
						<div class="d-image5">
							<b-img class="image-5" :src="require('../assets/img/projects/exitus/image5.png')" fluid alt="Responsive image"></b-img>
						</div>
					</b-col>
					<b-col cols="8" offset="2">
						<div class="design-3">
							<span class="txt-6">CREACIÓN DE PERSONAJES Y ESPACIOS</span>
							<div>
								<b-img class="image-6" :src="require('../assets/img/projects/exitus/image6.png')" fluid alt="Responsive image"></b-img>
							</div>
						</div>
					</b-col>
					<b-col cols="6" offset="4">
						<div>
							<b-img class="image-1" :src="require('../assets/img/projects/exitus/ExitusMujer-BocetoCalle.png')" fluid alt="Responsive image"></b-img>
						</div>
					</b-col>
					<b-col cols="10" offset="1">
						<div>
							<b-img class="image-1" :src="require('../assets/img/projects/exitus/ExitusMujer-Calle.png')" fluid alt="Responsive image"></b-img>
						</div>
					</b-col>
					<b-col cols="6" offset="1">
						<span class="txt-7">PICTOGRAMAS</span>
						<div>
							<b-img class="image-7" :src="require('../assets/img/projects/exitus/image7.png')" fluid alt="Responsive image"></b-img>
						</div>
					</b-col>
				</b-row>
				<b-row class="creation-fond">
					<b-col cols="4" offset="1">
						<div>
							<b-img class="image-orquidea" :src="require('../assets/img/projects/exitus/C03-1-Orquidea.png')" fluid alt="Responsive image"></b-img>
						</div>
					</b-col>
					<b-col cols="5" offset="1">
						<div class="content-creation">
							<h4>03 CREACIÓN DE CONTENIDO</h4>
							<p>
								Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum facilis recusandae repellendus aspernatur molestias dolorem ea dolores ad amet dolor. Ullam veritatis in ipsam asperiores laboriosam est ducimus libero exercitationem.
								<br> <br>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Est iure debitis similique natus reprehenderit voluptate culpa ipsum obcaecati adipisci eveniet quia porro et, odit impedit sed iste numquam neque quam!
								<br> <br>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae dignissimos labore unde vel recusandae commodi, odio architecto, dolores nostrum animi soluta tempora aliquam impedit eos quisquam eveniet, deserunt fuga minus.
							</p>
						</div>
					</b-col>
					<b-col cols="3" offset="1">
						<div>
							<span class="txt-8">CARRUSEL PARA FACEBOOK</span>
						</div>
					</b-col>
					<b-col cols="4">
						<div>
							<b-img class="image-casa" :src="require('../assets/img/projects/exitus/C04-2-CasaBlanca.png')" fluid alt="Responsive image"></b-img>
						</div>
					</b-col>
					<b-col cols="8" offset="2">
						<div class="content-comment">
							<p>“MARABUNTA HIZO UN TRABAJO <br> EXCELENTE, QUEDAMOS MUY <br> CONTENTOS CON SU DESEMPEÑO Y <br> SEGUIMIENTO EN TODO EL PROCESO.”</p>
							<h4 class="text-right">
								<span>Victor Rivera,</span> <br>
								Director de Marketing Exitus Credit
							</h4>
						</div>
					</b-col>
					<b-col cols="10" offset="1">
						<div class="video-exitus">
							<div class="text-center embed-responsive embed-responsive-16by9">
								<video id="video-project" class="embed-responsive-item" muted="muted" src="../assets/video/VID03.mp4"  poster="../assets/img/projects/exitus/image8.png"></video>
							</div>
							<div class="p-button-video" @click="playVideo">
								<b-icon icon="play"></b-icon>
							</div>
						</div>
					</b-col>
					<b-col cols="5" offset="1" class="content-final">
						<div>
							<b-img class="image-info" :src="require('../assets/img/projects/exitus/ExitusMujer-INF01.png')" fluid alt="Responsive image"></b-img>
						</div>
					</b-col>
					<b-col cols="5" class="content-final">
						<b-row class="justify-content-end">
							<b-col cols="10">
								<div>
									<b-img class="image-9" :src="require('../assets/img/projects/exitus/image9.png')" fluid alt="Responsive image"></b-img>
								</div>
							</b-col>
							<b-col cols="10">
								<div>
									<b-img class="image-10" :src="require('../assets/img/projects/exitus/image10.png')" fluid alt="Responsive image"></b-img>
								</div>
							</b-col>
						</b-row>
					</b-col>
					<b-col cols="12" class="text-center content-socials">
						<div><span class="txt-9">INFOGRAFÍA E IMAGENES MULTI PLATAFORMA</span></div>
						<button class="btn-more">CONOCE MÁS</button>
						<social-media-icons id="icons5" icon-class="classIcons"></social-media-icons>
					</b-col>
				</b-row>
				<b-row class="similar-projects">
					<b-col cols="10" offset="1">
						<span class="txt-10">PROYECTOS SIMILARES</span>
					</b-col>
				</b-row>
				<b-row class="justify-content-center similar-images">
					<!-- <b-col cols="3"> -->
						<!-- <div id="image-11"></div> -->
						<div class="proyecto motion" id="image-11">
							<img src="../assets/img/proyecto4.png" class="img-proyecto" alt="">
							<div class="over-proyecto over-s">
								<p class="name-project p-info-s">PROYECTO1</p><br>
								<p class="name-service">SERVICE1</p>
								<p class="name-service">SERVICE2</p>
							</div>
						</div>
					<!-- </b-col> -->
					<!-- <b-col cols="3"> -->
						<!-- <div class="image-12"></div> -->
						<div class="proyecto motion" id="image-12">
							<img src="../assets/img/proyecto6.png" class="img-proyecto" alt="">
							<div class="over-proyecto over-s">
								<p class="name-project p-info-s">PROYECTO2</p><br>
								<p class="name-service">SERVICE1</p>
								<p class="name-service">SERVICE2</p>
							</div>
						</div>
					<!-- </b-col> -->
					<!-- <b-col cols="3"> -->
						<!-- <div class="image-13"></div> -->
						<div class="proyecto motion" id="image-13">
							<img src="../assets/img/proyecto7.png" class="img-proyecto" alt="">
							<div class="over-proyecto over-s">
								<p class="name-project p-info-s">PROYECTO3</p><br>
								<p class="name-service">SERVICE1</p>
								<p class="name-service">SERVICE2</p>
							</div>
						</div>
					<!-- </b-col> -->
				</b-row>
				<b-row class="justify-content-center">
					<b-col cols="12" class="text-center start-proyect">
						<div class="p-centrar">
							<span class="txt-11">HABLEMOS DE TI, HABLEMOS DE TU PROYECTO</span>
							<div>
								<button class="btn-start">COMENZAR UN PROYECTO</button>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row>
					<!-- <b-col cols="12"><div class="up-content"></div></b-col> -->
					<b-col cols="12">
						<div class="up-styles gotham-bold"><span>{{ $t("contact.go_up") }}</span><b-icon icon="chevron-right"></b-icon></div>
					</b-col>
				</b-row>
			</div>
    </section>
</template>

<style>
/* NAVBAR */
#navbar-project{
    background: #fff;
    width: 100vw;
    height: 70px;
    position: fixed !important;
    top: 0 !important;
    z-index: 1;
} 
#navbar-project.hide{
    top: -150px !important;
    /* display: none; */
}
.img-nav-project{
    width: 5rem !important;
    height: 5rem !important;
    margin-left: 2% !important;
    z-index: 4;
}
.label-nav-project{
    font-family: 'Gotham Bold Regular';
    color:#04182E !important;
    position: absolute;
    margin-top: 1.3rem;
}

/* MENU */

.header-azul-project{
    height: 12vh;
    width: 20vw;
    position: fixed;
    top: 0;
    left: 0;
    background: transparent;
    opacity: 1;
    box-shadow: inset 0 0 0 0 #2ABECC;
    -webkit-transition: all ease-in-out 1s !important;
    -moz-transition: all ease-in-out 1s !important;
    transition: all .1s ease !important;
    z-index: 2;
}

.menu-project{
    background-color: transparent;
    background-image: url(../assets/img/MenuSecundario.svg);
    top: 20px;
    cursor: pointer !important;
    width: 2rem !important;
    height: 2rem !important;
    right: 60px !important;
    position: absolute !important;
    transition: box-shadow .2s cubic-bezier(.25, .5, .22, .5) !important;
    z-index: 3 !important;
}

.input-menu-project{
    display: none;
}

.input-menu-project:checked ~ label .menu-project{
    box-shadow: 0 0 0 100vh #2ABECC, 1 0 0 100vw #2ABECC !important;
    /* revisar como hacer que el panel tenga el tamaño de la pantalla */
    background-color: #2ABECC;
    background-image: url(../assets/img/Tache.svg); 
    z-index: 3;
}

.input-menu-project:checked ~ .header-azul-project{
    display: block;
    height: 100vh;
    width: 100vw;
    /* position: fixed; */
    background:  #2ABECC;
    box-shadow: inset 0 0 0 0 #2ABECC;
    opacity: 1;
    transition: box-shadow .2s cubic-bezier(.20, 1, .22, 1) !important;
}

.input-menu-project:checked ~ .ul-menu-project{
    display:block;
}

.input-menu-project:checked ~ .li-menu-project a{
    color: white !important;
}

.ul-menu-project{
    font-family: 'Gotham Bold Regular';
    letter-spacing: 4.24px;
    font-size: 52px !important;
    line-height: 61px !important;
    position: absolute;
    top: 230px;
    left: 45%;
    list-style: none;
    font-size: 45px;
    display: none;
    transition: .25s .1s cubic-bezier(0, 1.07, 0, 1.02);
    z-index: 3;
}

.li-menu-project{
    margin-top: 20px;
}

.li-menu-project a{
    color: white !important;
    transform: all 300ms !important;
    position: relative !important;
}

.li-menu-project a:before{
    content: '';
    position: absolute !important;
    top: 50px !important;
    left: -30px !important;
    width: 0 !important;
    height: 5px !important;
    background: #04182E !important;
    transition: all 300ms cubic-bezier(1, 0, 0, 1) !important;
}

.li-menu-project a:hover:before{
    width: 30px !important;
}
.li-menu-project a:hover{
    color: #04182E !important;
    margin-left: 30px !important;
} 
.a-menu-project{ 
    color: #00cec9 !important;
    display: block !;
    text-decoration: none !important;
}
.div-lenguaje-project{
	display: none;
	color: white;
}
.input-menu-project:checked ~ .div-lenguaje-project{
    display:block;
}

/*  */
.container-project{
	margin-top: 8%;
}

.back-fixed{
	position: fixed;
	top: 15%;
}

.link-back{
	color: #1D2B3C;
	font-family: "Gotham Bold Regular";
	font-size: 20px;
	letter-spacing: 1.54px;
	line-height: 23px;
}
.link-back:hover{
	display:inline-block; 
	text-decoration: none;
	transform: scaleX(1.1); 
	transform-origin: 0 0;
	color: #1D2B3C;
}

.s-title{
	font-family: "Gotham Bold Regular";
	font-size: 20px;
	letter-spacing: 1.54px;
	line-height: 30px;
}

.s-content{
	font-family: "Gotham Book Regular";
	font-size: 20px;
	letter-spacing: 1.54px;
	line-height: 30px;
}

.p-text{
	display: inline-block;
	font-family: "Gotham Bold Regular";
	font-size: 20px;
	height: 100%;
	position: relative;
	letter-spacing: 1.54px;
	line-height: 23px; 
}

.p-text .div-back{
	position: fixed;
	bottom: 10%;
	left: 1%;
	-webkit-transform: rotate(-90deg); 
	-moz-transform: rotate(-90deg);
	-o-transform: rotate(-90deg); 
	transform: rotate(-90deg); 
}

.p-text .div-next{
	position: fixed;
	bottom: 10%;
	right: 1%;
	-webkit-transform: rotate(-90deg); 
	-moz-transform: rotate(-90deg);
	-o-transform: rotate(-90deg); 
	transform: rotate(-90deg); 
}

.objective{
	background-color: #04182E;
	color: #FFFFFF;
}

.objective h4{
	font-family: "Gotham Bold Regular";
	font-size: 32px;
	line-height: 36px;
	letter-spacing: 2.46px;
	padding: 10% 0 5% 5%;
}

.objective p{
	font-family: "Gotham Book Regular";
	font-size: 20px;
	line-height: 28px;
	letter-spacing: 1.54px;
	padding: 0 8% 10% 12%;
}

.objective-2{
	margin-top: 10%;
}

.txt-1{
	font-family: "Gotham Book Regular";
	color: #1D1D1D;
	font-size: 20px;
	line-height: 21px;
	margin-left: 5%;
	opacity: 0.7;
}

.o-image1{
	margin-top: 10%;
}

.image-0{
	width: 70%;
}

.objective-3{
	margin-top: 5%;
}

.txt-2{
	font-family: "Gotham Book Regular";
	color: #1D1D1D;
	font-size: 20px;
	line-height: 21px;
	opacity: 0.7;
}

.image-4{
	width: 70%;
}

.design{
	background-color: #106180;
	color: #FFFFFF;
}

.design h4{
	font-family: "Gotham Bold Regular";
	font-size: 32px;
	line-height: 36px;
	letter-spacing: 2.46px;
	padding: 5% 0 5% 0;
	text-align: center;
}

.design p{
	font-family: "Gotham Book Regular";
	font-size: 20px;
	line-height: 28px;
	letter-spacing: 1.54px;
	padding: 0 6% 6% 6%;
}

.d-image5{
	margin-top: 5%;
}

.image-5{
	width: 90%;
}

.design-3{
	margin-top: 5%;
}

.txt-6{
	font-family: "Gotham Book Regular";
	color: #1D1D1D;
	font-size: 20px;
	line-height: 19px;
	opacity: 0.7;
}

.image-6{
	width: 50%;
}

.txt-7{
	font-family: "Gotham Book Regular";
	color: #1D1D1D;
	font-size: 20px;
	line-height: 19px;
	opacity: 0.7;
}

.image-7{
	width: 100%;
}

.creation-fond{
	background: linear-gradient(#E6E6E5, #E6E6E5);
	background-position: center 17rem;
	background-repeat: no-repeat;
}

.image-orquidea{
	margin-top: 20%;
	width: 90%;
}

.content-creation{
	background-color: #2ABECC;
	color: #FFFFFF;
}

.content-creation h4{
	font-family: "Gotham Bold Regular";
	font-size: 32px;
	line-height: 36px;
	letter-spacing: 2.46px;
	padding: 10% 0 5% 5%;
}

.content-creation p{
	font-family: "Gotham Book Regular";
	font-size: 20px;
	line-height: 28px;
	letter-spacing: 1.54px;
	padding: 0 8% 10% 12%;
}

.txt-8{
	font-family: "Gotham Book Regular";
	color: #1D1D1D;
	font-size: 20px;
	line-height: 19px;
	opacity: 0.7;
}

.image-casa{
	width: 80%;
}

.content-comment{
	margin-top: 10%;	
}

.content-comment p{
	font-family: "Gotham Bold Regular";
	color: #1D1D1D;
	font-size: 45px;
	line-height: 52px;
	letter-spacing: 3.46px;
}

.content-comment h4{
	margin-top: 5%;
}

.content-comment h4{
	font-family: "Gotham Book Regular";
	color: #1D1D1D;
	font-size: 27px;
	line-height: 28px;
}

.content-comment h4 span{
	font-family: "Gotham Medium Regular";
}

.video-exitus{
	margin-top: 10%;
}

.p-button-video:hover {
  background-position: 0 100%;
}

.p-button-video:hover .b-icon{
  color: #FFF !important;
}

.p-button-video{
  background-size: 100% 200%;
  background-image: linear-gradient(to top, #04182E 50%, transparent 50%);
  border: 3px solid #1D2B3C !important;
  bottom: 36%;
  cursor: pointer;
  padding: 8px; 
  position: absolute;
  left: -2%;
  transition: background-position 1s;
  -webkit-transition: background-position 1s;
  -moz-transition: background-position 1s;
}

.p-button-video .b-icon{
  color: #1D2B3C;
  font-size: 78px;
}

.content-final{
	margin-top: 5%;
}

.image-info{
	width: 90%;
}

.image-9{
	width: 100%;
}

.image-10{
	margin-top: 6%;
	width: 100%;
}

.content-socials{
	margin-top: 5%;
}

.btn-more:hover{
	color:#FFFFFF;
	background-position: -100% 0 !important;
}

.btn-more{
	font-family: "Gotham Book Regular";
	background: transparent !important;
	border: 3px solid #04182E !important;
	border-radius: 0% !important;
	color: #04182E;
	font-size: 20px;
	margin: 5% 0 0 0;
	text-decoration: none;
	width: 350px;
	height: 50px;
	background-size: 200% 100% !important;
	background-image: linear-gradient(to right, transparent 50%, #04182E 50%) !important;
	-webkit-transition: background-position 1s;
	-moz-transition: background-position 1s;
	transition: background-position 1s;
}

#icons5{
  margin-top: 2%;
  margin-bottom: 5%;
}

#icons5 svg{
  cursor: pointer;
  margin-right: 7px;
  margin-left: 7px;
  margin-top: 2px;
  width: 34px;
  height: 34px;
}

#icons5 a:link, #icons5 a:visited, #icons5 a:hover, #icons5 a:active{
  color: #04182E;
}

.txt-9{
	font-family: "Gotham Book Regular";
	color: #1D1D1D;
	font-size: 20px;
	line-height: 19px;
	letter-spacing: -0.38px;
	opacity: 0.7;
}

.similar-projects{
	margin-top: 5%;
}

.txt-10{
	font-family: "Gotham Bold Regular";
	color: #1D2B3C;
	font-size: 32px;
	line-height: 36px;
	letter-spacing: 2.46px;
}

.similar-images{
	margin-top: 3%;
	margin-bottom: 5%;
}

/* .image-11{
	background-image: url('../assets/img/projects/exitus/image11.png');
	background-position: center center;
	background-repeat: no-repeat;
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
	height: 278px;
	width: 100%;
} */
#image-11{
	width: 482px;
	height: 278px;
	/* background: red; */
}
#image-12{
	width: 535px;
	height: 278px;
	/* background: red; */
}

#image-13{
	width: 471px;
	height: 278px;
	/* background: red; */
}

.start-proyect{
	background-image: linear-gradient(
		rgba(29, 43, 60, 0.5),
		rgba(29, 43, 60, 0.5)
	), url("../assets/img/FondoContacto.jpg");
	background-position: center center;
	background-repeat: no-repeat;
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;

	display: table;
	height: 100vh;
}

.p-centrar{
	color: #FFF;
	display: table-cell;
	vertical-align: middle;
}

.txt-11{
	font-family: "Gotham Bold Regular";
	color: #FFFFFF;
	font-size: 45px;
	line-height: 52px;
	letter-spacing: 3.46px;
}

.btn-start:hover{
	color:#04182E;
	background-position: -100% 0 !important;
}

.btn-start{
	font-family: "Gotham Book Regular";
	background: transparent !important;
	border: 3px solid #FFF !important;
	border-radius: 0% !important;
	color: #FFFFFF;
	font-size: 20px;
	margin: 2%;
	text-decoration: none;
	width: 350px;
	height: 50px;
	background-size: 200% 100% !important;
	background-image: linear-gradient(to right, transparent 50%, #FFF 50%) !important;
	-webkit-transition: background-position 1s;
	-moz-transition: background-position 1s;
	transition: background-position 1s;
}




.image-1{
	width: 100%;
}


@media (max-width: 1800px) {
	.link-back{
		font-size: 16px;
		line-height: 22px;
		letter-spacing: 1.23px;
	}
	.s-title{
		font-size: 16px;
		letter-spacing: 1.23px;
	}
	.s-content{
		font-size: 16px;
		letter-spacing: 1.23px;
	}
	.p-text{
		font-size: 16px;
		line-height: 22px;
		letter-spacing: 1.23px;
	}
	.objective h4{
		font-size: 20px;
		line-height: 28px;
		letter-spacing: 1.54px;
	}
	.objective p{
		font-size: 16px;
		line-height: 25px;
		letter-spacing: 1.23px;
	}
	.txt-1{
		font-size: 16px;
		line-height: 18px;
	}
	.txt-2{
		font-size: 16px;
		line-height: 18px;
	}
	.design h4{
		font-size: 20px;
		line-height: 28px;
		letter-spacing: 1.54px;
	}
	.design p{
		font-size: 16px;
		line-height: 25px;
		letter-spacing: 1.23px;
	}
	.txt-6{
		font-size: 16px;
		line-height: 18px;
	}
	.txt-7{
		font-size: 16px;
		line-height: 10px;
	}
	.content-creation h4{
		font-size: 20px;
		line-height: 28px;
		letter-spacing: 1.54px;
	}
	.content-creation p{
		font-size: 16px;
		line-height: 25px;
		letter-spacing: 1.23px;
	}
	.txt-8{
		font-size: 16px;
		line-height: 19px;
	}
	.content-comment p{
		font-size: 28px;
		line-height: 40px;
		letter-spacing: 2.16px;
	}
	.content-comment h4{
		font-size: 20px;
		line-height: 25px;
	}
	.txt-9{
		font-size: 16px;
		line-height: 19px;
		letter-spacing: -0.3px;
	}
	.txt-10{
		font-size: 20px;
		line-height: 28px;
		letter-spacing: 1.54px;
	}
	.txt-11{
		font-size: 28px;
		line-height: 40px;
		letter-spacing: 2.16px;
	}
}

@media (max-width: 960px) {
	.link-back{
		font-size: 14px;
		line-height: 20px;
		letter-spacing: 1.08px;
	}
	.s-title{
		font-size: 15px;
		letter-spacing: 1.16px;
	}
	.s-content{
		font-size: 15px;
		letter-spacing: 1.16px;
	}
	.objective h4{
		font-size: 18px;
		line-height: 26px;
		letter-spacing: 1.39px;
	}
	.objective p{
		font-size: 15px;
		line-height: 23px;
		letter-spacing: 1.16px;
	}
	.txt-1{
		font-size: 14px;
		line-height: 15px;
	}
	.txt-2{
		font-size: 14px;
		line-height: 15px;
	}
	.design h4{
		font-size: 18px;
		line-height: 26px;
		letter-spacing: 1.39px;
	}
	.design p{
		font-size: 15px;
		line-height: 23px;
		letter-spacing: 1.16px;
	}
	.txt-6{
		font-size: 14px;
		line-height: 15px;
	}
	.txt-7{
		font-size: 14px;
		line-height: 15px;
	}
	.content-creation h4{
		font-size: 18px;
		line-height: 26px;
		letter-spacing: 1.36px;
	}
	.content-creation p{
		font-size: 15px;
		line-height: 23px;
		letter-spacing: 1.16px;
	}
	.txt-8{
		font-size: 14px;
		line-height: 15px;
	}
	.content-comment p{
		font-size: 18px;
		line-height: 28px;
		letter-spacing: 1.39px;
	}
	.content-comment h4{
		font-size: 15px;
		line-height: 23px;
	}
	.txt-9{
		font-size: 14px;
		line-height: 19px;
		letter-spacing: -0.27px;
	}
	.txt-10{
		font-size: 18px;
		line-height: 26px;
		letter-spacing: 1.39px;
	}
	.txt-11{
		font-size: 18px;
		line-height: 28px;
		letter-spacing: 1.39px;
	}
}

@media screen and (max-width: 1800px) and (min-width: 961px){

    /* NAV OCULTO */

    .ul-menu-project{
        font-family: 'Gotham Bold Regular';
        letter-spacing: 4.24px;
        font-size: 30px !important;
        line-height: 37px !important;
        top: 200px;
        left: 40%;
        list-style: none;
        display: none;
        transition: .25s .1s cubic-bezier(0, 1.07, 0, 1.02);
        /* z-index: 3; */
    }
    .li-menu-project a:before{
        content: '';
        position: absolute !important;
        top: 30px !important;
        left: -25px !important;
        width: 0 !important;
        height: 4px !important;
        background: #04182E !important;
        transition: all 300ms cubic-bezier(1, 0, 0, 1) !important;
    }

    .li-menu-project a:hover:before{
        width: 25px !important;
	}
	
	#image-11{
		width: 258px;
		height: 149px;
	}

	#image-12{
		width: 258px;
		height: 149px;
	}
	#image-13{
		width: 253px;
		height: 149px;
	}

}
</style>

<script>
import SocialMediaIcons from './socialMediaIcons'
import LanguageSwitcher from './LanguageSwitcher'

export default {
	name: 'Project',
  components: {
    SocialMediaIcons,
	LanguageSwitcher
  } ,
  methods:{
		habilitarp(){
				
			let scll = document.querySelector("body");
			this.scroll=true;
			scll.setAttribute("style", "overflow-y: visible");
			document.querySelector('.input-menu-project').removeAttribute("checked");
			document.getElementById('nav-project').removeAttribute('checked');
			document.querySelector('.input-menu-project').checked=false;
		},
		playVideo() {
      let playVideoP = document.getElementById('video-project');

      if (playVideoP.paused || playVideoP.muted === true) {
        playVideoP.play();
        playVideoP.muted = false;
        playVideoP.requestFullscreen();
      } else {
        playVideoP.pause();
      }
		},
		closeVideo() {
      let playVideoP = document.getElementById('video-project');
      playVideoP.muted = true;
    }
  },
  mounted: function () {

	const vm=this;     
	var doc = document.documentElement;
	var w   = window;
	vm.scroll =true;

	var curScroll       = w.scrollY || doc.scrollTop;
	var prevScroll      = w.scrollY || doc.scrollTop;
	var curDirection    = 0;
	var prevDirection   = 0;
	var headerP= document.getElementById('navbar-project');

	var checkScrollP = function(){

		if(vm.scroll===true){
			// console.log("se esta moviendo???");

			curScroll       = w.scrollY || doc.scrollTop;
			
			if(curScroll > prevScroll){
				curDirection = 2;
				// console.log(curDirection);
			}
			else{
				curDirection = 1;
				// console.log(curDirection);
			}

			if(curDirection !== prevDirection){
				togleHeaderP();
			}
			prevDirection=curDirection;
			prevScroll=curScroll;
		}
	}
	var togleHeaderP = function(){
		
		if(curDirection === 2 ){
			headerP.classList.add('hide');
		}
		else if(curDirection === 1){
			headerP.classList.remove('hide');
		}
	}


	window.addEventListener('scroll',checkScrollP);

	//EVENT TO CHECK MENU AND DISABLE SCROLL

	const selectElement = document.querySelector('.input-menu-project');
	// const selectLink = document.querySelector('.a-menu-h');

	selectElement.addEventListener('change', () => {
		var decider = document.getElementById('nav-project');
		let scll = document.querySelector("body");
		if(decider.checked){

			// disableScroll();
			scll.setAttribute("style", "overflow-y: hidden");
			vm.scroll=false;
		} else {
			// enableScroll();
			scll.setAttribute("style", "overflow-y: visible");
			vm.scroll=true;
		}
	});































        // const vm=this;     
        // var doc = document.documentElement;
        // var w   = window;
        // vm.scroll =true;

        // var curScroll       = w.scrollY || doc.scrollTop;
        // // var sectionScroll   = w.scrollY || doc.scrollTop;
        // // var staticScroll    = w.scrollY || doc.scrollTop;
        // var prevScroll      = w.scrollY || doc.scrollTop;
        // var curDirection    = 0;
        // var prevDirection   = 0;

        // var header= document.getElementById('navbar-project');
		// 		// console.log("se esta moviendo???");

				
	// 		var checkScrollp = function(){

    //             curScroll       = w.scrollY || doc.scrollTop;
    //             // staticScroll    = w.scrollY || doc.scrollTop;
                
    //             if(curScroll > prevScroll){
    //                 curDirection = 2;
    //                 // console.log(curDirection);
    //             }
    //             else{
    //                 curDirection = 1;
    //                 // console.log(curDirection);
    //             }

    //             if(curDirection !== prevDirection){
    //                 togleHeaderP();
    //             }
    //             prevDirection=curDirection;
    //             prevScroll=curScroll;
            
	// 		}
	// 		var togleHeaderP = function(){
				
	// 			if(curDirection === 2 ){
	// 				header.classList.add('hide');
	// 			}
	// 			else if(curDirection === 1){
	// 				header.classList.remove('hide');
	// 			}
	// 		}


	// 	window.addEventListener('scroll',checkScrollp);

	// //ESTA PARTE HACE COSAS RARAS
		
	// 	const selectElem = document.querySelector('.input-menu-project');
    //     // const selectLink = document.querySelector('.a-menu-h');

    //     selectElem.addEventListener('change', () => {
	// 		console.log("HAY UN CAMBIO");
    //         var deciderPro = document.getElementById('nav-project');
    //         let scll = document.querySelector("body");
    //         if(deciderPro.checked){

    //             // disableScroll();
    //             scll.setAttribute("style", "overflow-y: hidden");
    //             // vm.scroll=false;
    //         } else {
    //             // enableScroll();
    //             scll.setAttribute("style", "overflow-y: visible");
    //             // vm.scroll=true;
    //         }
		//     });
		
		document.addEventListener('fullscreenchange', exitHandler2);
    const vm2 = this;
    function exitHandler2() {
      if (!document.fullscreenElement) {
          vm2.closeVideo();
      }
    }  

    class ViewPort{
      static visible(el){
        let coords = el.getBoundingClientRect();
        let windowsHeight = document.documentElement.clientHeight;
  
        return (coords.top < windowsHeight && (coords.top * -1) < windowsHeight);
      }
    }

    class PlayOnViewPort{
      constructor(video_selector){
        this.video = document.getElementById(video_selector);
        this.evaluate = this.evaluate.bind(this);
        this.bindEvents();
      }
    
      bindEvents(){
        window.addEventListener('scroll',this.evaluate)
      }
  
      evaluate(){
        if(ViewPort.visible(this.video)){
          this.video.play().catch((e)=>{ console.log(e)});
        }else{
          this.video.pause();
        }
      }
    }

    (function(){
      new PlayOnViewPort("video-project");
    })();
  }  
}
</script>